import { useEffect, useState } from 'react'
import * as Constants from '../../../../../../constants/constants'
import constSubmittedType from '../../../../../../constants/submittedType'

//Hook Service
import useWebService from '../../../../../../services/web/useWebService'

//Store & Action
import useAppFolderAndTabStore, * as appFolderAndTabStoreType from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'
import useLoading from '../../../../../../control/loading/useLoading'
import { GetProjectResultType } from '../../../../../../services/web/types/responseWebServiceTypes'
import constSubmittedStep from '../../../../../../constants/submittedStep'
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import projectStatus from '../../../../../../constants/projectStatus'

const useButtonSubmittedWithdraw = () => {
    const [isShowButton, setStateIsShowButton] = useState<boolean>(false)

    const checkPermission = useCheckPermission()
    const loadingHook = useLoading()
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectStore = useManageProjectStore()
    const manageProjectAction = useManageProjectAction()
    const isUserResearcher = checkPermission.isUserResearcher()
    const isUserAdmin = checkPermission.isUserAdmin()
    const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
    const currentFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderSelected

    const callWebService = useWebService()

    useEffect(() => {
        const conditionShowButton = () => {
            const currentProjectStep = manageProjectStore.projectData?.stepID ?? constSubmittedStep.submit

            //ตัวเองไม่ได้เป็นการยื่นแบบถอนการยื่น
            const myselfNotWithdrawSubmitted: boolean =
                manageProjectStore.projectData?.submitTypeInfo?.value !== constSubmittedType.withdrawalSubmitted

            const haveAboveSubmitted: boolean =
                manageProjectStore.projectData?.aroundSubmittedIDInfo?.nextSubmittedID !== null &&
                manageProjectStore.projectData?.aroundSubmittedIDInfo?.nextSubmittedID !== undefined

            const isPermissionUser: boolean = isUserResearcher || isUserAdmin
            const isLastFolder: boolean = latestFolder?.submittedID === currentFolder?.submittedID

            //แสดงเมื่อไม่มี folder อยู่บนตัวมัน
            if (!haveAboveSubmitted && myselfNotWithdrawSubmitted) {
                if (manageProjectStore.projectData?.submittedID && (isUserAdmin || isUserResearcher)) {
                    const prjSubmittedStatus = manageProjectStore.projectData?.submittedStatusInfo?.value
                    const condition1 =
                        isPermissionUser &&
                        isLastFolder &&
                        prjSubmittedStatus !== constSubmittedStatus.complete &&
                        currentProjectStep !== constSubmittedStep.submit
                    const condition2 =
                        prjSubmittedStatus === constSubmittedStatus.incorrectDocument ||
                        prjSubmittedStatus === constSubmittedStatus.waitingEditProject
                    const condition3 = isUserAdmin && condition2
                    const conditionDraft =
                        (manageProjectStore.projectData.isDraft ||
                            manageProjectStore.projectData.submittedStatusInfo?.value === constSubmittedStatus.draft ||
                            !manageProjectStore.projectData.submittedStatusInfo) &&
                        manageProjectStore.projectData.projectStatusInfo?.value !== projectStatus.completed
                    if (condition1 || condition3 || conditionDraft) {
                        setStateIsShowButton(true)
                    }
                } else {
                    setStateIsShowButton(false)
                }
            } else if (
                !myselfNotWithdrawSubmitted &&
                currentProjectStep !== constSubmittedStep.submit &&
                isPermissionUser &&
                isLastFolder &&
                !latestFolder?.folderName_th?.includes('แก้ไขหลังพิจารณา')
            ) {
                setStateIsShowButton(true)
            } else {
                setStateIsShowButton(false)
            }
        }

        conditionShowButton()

        return () => {
            loadingHook.loadingClose()
        }
    }, [
        manageProjectStore.projectData?.projectID,
        manageProjectStore.projectData?.submittedID,
        latestFolder?.submittedID,
        currentFolder?.submittedID,
    ])

    const createFolderWithdrawSubmitted = async () => {
        const projectData = manageProjectStore.projectData
        const latestFolder: appFolderAndTabStoreType.FolderType = appFolderAndTabStore.folderList[0]
        const cloneFolderList: Array<appFolderAndTabStoreType.FolderType> = [
            { ...Constants.customFolder.withdrawSubmitted, isLastProcess: true },
            ...appFolderAndTabStore.folderList.map((itm) => ({ ...itm, isLastProcess: false })),
        ]

        if (projectData?.projectID && latestFolder?.submittedID) {
            try {
                loadingHook.loadingOpen()
                const { result } = await callWebService.getProjectByID(projectData.projectID, latestFolder.submittedID)
                let customResult: Partial<GetProjectResultType> | null = null
                customResult = {
                    ...result,
                    submittedID: undefined,
                    stepID: constSubmittedStep.submit,
                    latestDocument: [],
                    documentInfo: [],
                    isFlowApproveWithComment: false,
                    synthesisApproveStatusInfo: undefined,
                    submitTypeInfo: {
                        value: constSubmittedType.withdrawalSubmitted,
                        nameTH: Constants.customFolder.withdrawSubmitted.folderName_th,
                        nameEN: Constants.customFolder.withdrawSubmitted.folderName_en,
                    },
                }
                manageProjectAction.setProjectData(customResult as GetProjectResultType)

                //SetFolder
                const folder = cloneFolderList?.filter((itm: any) => itm.id !== Constants.customFolder.docAdditional.id)
                //แบบนี้ลดจำนวนการ render ลดการเกิดการไม่ทันกันของข้อมูล
                appFolderAndTabAction.setState({
                    folderList: folder,
                    folderSelected: Constants.customFolder.withdrawSubmitted,
                    tabSelected: Constants.menuTab.tab21,
                    tabRenderList: [Constants.menuTab.tab21],
                    tabIndexSelected: 0,
                })
            } catch (ex) {
                console.error('useButtonSubmittedWithdraw.ts => createFolderWithdrawSubmitted : ', ex)
            } finally {
                loadingHook.loadingClose()
            }
        }
    }

    const onClickWithdraw = () => {
        createFolderWithdrawSubmitted()
    }
    return {
        isShowButton,
        onClickWithdraw,
    }
}

export default useButtonSubmittedWithdraw
